import * as React from 'react';
import Chip from '@mui/material/Chip';

import { alpha, styled } from '@mui/material/styles';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InfoIcon from '@mui/icons-material/Info';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DoneIcon from '@mui/icons-material/Done';

const StyledChip = styled(Chip)(({ theme }) => {
  const palette = (theme.vars || theme).palette;
  const { mode, neutral } = palette;
  const isDark = mode === 'dark';

  return {
    justifyContent: 'left',
    '& .icon': {
      color: 'inherit',
    },
    '&.AGUARDANDO': {
      color: palette.info.dark,
      border: `1px solid ${palette.info.main}`,
    },
    '&.ACEITO': {
      color: palette.success.dark,
      border: `1px solid ${palette.success.main}`,
    },
    '&.EXPIRADA': {
      color: palette.warning.dark,
      border: `1px solid ${palette.warning.main}`,
    },
    '&.EXPIRED': {
      color: palette.warning.dark,
      border: `1px solid ${palette.warning.main}`,
    },
    '&.NEGADO': {
      color: palette.error.dark,
      border: `1px solid ${palette.error.main}`,
    },
    '&.CANCELADA': {
      color: palette.error.dark,
      border: `1px solid ${palette.error.main}`,
    },
    '&.CANCELADO': {
      color: palette.error.dark,
      border: `1px solid ${palette.error.main}`,
    },
    '&.BLOQUEADO': {
      color: palette.warning.dark,
      border: `1px solid ${palette.warning.main}`,
    },
    '&.ATIVO': {
      color: palette.success.dark,
      border: `1px solid ${palette.success.main}`,
    },
    '&.AGUARDANDO_VALIDACAO': {
      color: palette.info.dark,
      border: `1px solid ${palette.info.main}`,
    },
    '&.VALIDADO': {
      color: palette.success.dark,
      border: `1px solid ${palette.success.main}`,
    },
    '&.INVALIDADO': {
      color: palette.error.dark,
      border: `1px solid ${palette.error.main}`,
    },
    '&.RESTRICAO_AREA': {
      color: palette.warning.dark,
      border: `1px solid ${palette.warning.main}`,
    },
    '&.AVAILABLE': {
      color: palette.info.dark,
      border: `1px solid ${palette.info.main}`,
    },
    '&.ACCEPTED': {
      color: palette.success.dark,
      border: `1px solid ${palette.success.main}`,
    },
    '&.FINALIZADA': {
      color: palette.success.dark,
      border: `1px solid ${palette.success.main}`,
    },
    '&.CANCEL': {
      color: palette.error.dark,
      border: `1px solid ${palette.error.main}`,
    },
    '&.VALIDO': {
      color: palette.success.dark,
      border: `1px solid ${palette.success.main}`,
    },
    '&.INVALIDO': {
      color: neutral[600],
      border: `1px solid ${neutral[400]}`,
    },
    '&.NAO_ENVIADA': {
      color: isDark ? neutral[300] : neutral[700],
      border: `1px solid ${neutral[500]}`,
      backgroundColor: alpha(neutral[500], isDark ? 0.15 : 0.08),
    },
  };
});

const Status = React.memo((props) => {
  const { status, label } = props;

  let icon = null;
  if (status === 'NEGADO' || status === 'CANCELADA' || status === 'CANCELADO' || status === 'INVALIDADO') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'AGUARDANDO' || status === 'AGUARDANDO_VALIDACAO') {
    icon = <InfoIcon className="icon" />;
  } else if (status === 'EXPIRADA' || status === 'EXPIRED' || status === 'BLOQUEADO') {
    icon = <AutorenewIcon className="icon" />;
  } else if (status === 'ACEITO' || status === 'VALIDADO' || status === 'ATIVO' || status === 'ACCEPTED' || status === 'VALIDO' || status === 'FINALIZADA') {
    icon = <DoneIcon className="icon" />;
  } else if (status === 'AVAILABLE') {
    icon = <InfoIcon className="icon" />;
  } else if (status === 'CANCEL') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'RESTRICAO_AREA') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'INVALIDO') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'NAO_ENVIADA') {
    icon = <InfoIcon className="icon" />;
  }

  return (
    <StyledChip
      className={status}
      icon={icon}
      size="small"
      label={label || status}
      variant="outlined"
    />
  );
});

export function renderStatus(params) {
  if (params.value == null) {
    return '';
  }

  return <Status status={params.value} label={params.label} />;
}